import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { requestLoginInstructor } from "../utils/resource";

import "../styles/Login.css";
import videoBg from "../assets/video_web.mp4";
import logo from "../imgs/logo-jessica-2.svg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      setError("Por favor, preencha todos os campos.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      await requestLoginInstructor(email, password, navigate);
    } catch (err) {
      setError(err.message || "Email ou senha inválidos. Tente novamente.");
      setPassword("");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="auth-video-container">
        <video
          src={videoBg}
          autoPlay
          loop
          muted
          playsInline
          className="auth-video-bg"
        />
        <div className="auth-overlay"></div>
      </div>

      <div className="auth-container">
        <header className="auth-header">
          <Link to="/" className="auth-back-button">
            <FontAwesomeIcon icon={faArrowLeft} /> Voltar
          </Link>
        </header>

        <img src={logo} alt="Logo" className="auth-logo" />

        <div className="auth-card">
          <h2 className="auth-card-title">Acesso Restrito</h2>
          <p className="auth-card-subtitle">Área exclusiva para instrutores.</p>
          <form onSubmit={handleSubmit} className="auth-form">
            <input
              id="email"
              name="email"
              type="email"
              placeholder="seu-email@exemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              required
            />
            <input
              id="password"
              name="password"
              type="password"
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="auth-input"
              required
            />
            <button
              type="submit"
              disabled={isLoading}
              className="auth-btn-submit"
            >
              {isLoading ? (
                "Entrando..."
              ) : (
                <>
                  <FontAwesomeIcon icon={faSignInAlt} /> Entrar
                </>
              )}
            </button>
          </form>
          {error && <p className="auth-error-message">{error}</p>}
        </div>

        <footer className="auth-footer">
          <p>© 2026 - Todos os direitos reservados.</p>
        </footer>
      </div>
    </>
  );
};

export default Login;
